<template>
  <section class="p-2">
    <v-card>
      <Overlay :showOverlay="show_overlay" />
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <span class="text-h5"
          ><v-icon class="me-2">mdi-shield-lock</v-icon>
          <span class="headingFontsize">Password Format</span></span
        >
        <div>
          <bread-crumb :bread-crumbs="['Password Format']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text class="pt-4">
        <v-form v-model="valid" ref="passwordFormat">
          <v-row class="d-flex justify-space-around m-0 p-0" no-gutters>
            <v-col cols="12" md="5">
              <label class="required font-weight-large my-0">
                Wrong login attempts Limit:
              </label>
              <v-text-field
                v-model="editedItem.wrong_login_attempts_limit"
                class="rounded"
                type="number"
                hide-spin-buttons
                :rules="FieldNumbRequired('Wrong login attempts Limit')"
                dense
                outlined
                placeholder="Wrong login attempts Limit"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
              <label class="required font-weight-large my-0">
                Minimum Password Length:
              </label>
              <v-text-field
                v-model="editedItem.minimum_password_length"
                class="rounded"
                type="number"
                :rules="FieldNumbRequired('Minimum Password Length')"
                hide-spin-buttons
                dense
                outlined
                placeholder="Enter Minimum Password Length"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="d-flex justify-space-around" no-gutters>
            <v-col cols="12" md="5">
              <label class="required font-weight-large my-0">
                Password Record History Number:
              </label>
              <v-text-field
                v-model="editedItem.password_record_history_number"
                class="rounded"
                type="number"
                :rules="FieldNumbRequired('Password Record History Number')"
                hide-spin-buttons
                dense
                outlined
                placeholder="Enter Password Record History Number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
              <label class="required font-weight-large my-0">
                Special Character:
              </label>
              <v-text-field
                v-model="editedItem.special_character"
                class="rounded"
                type="number"
                :rules="FieldNumbRequired('Special Charactor')"
                hide-spin-buttons
                dense
                outlined
                placeholder="Special Character"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-space-around" no-gutters>
            <v-col cols="12" md="5">
              <label class="required font-weight-large my-0"> Numeric: </label>
              <v-text-field
                v-model="editedItem.numeric"
                class="rounded"
                type="number"
                :rules="FieldNumbRequired('Numeric')"
                hide-spin-buttons
                dense
                outlined
                placeholder="Numeric"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
              <label class="required font-weight-large my-0">
                Capital Alphabet:
              </label>
              <v-text-field
                v-model="editedItem.capital_alphabet"
                class="rounded"
                type="number"
                :rules="FieldNumbRequired('Capital Alphabet')"
                hide-spin-buttons
                dense
                outlined
                placeholder="Capital Alphabet"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="d-flex justify-space-around" no-gutters>
            <v-col cols="12" md="5">
              <label class="required font-weight-large my-0">
                Lock User (Within Days if not logged in):
              </label>
              <v-text-field
                v-model="editedItem.lock_user_within_days_if_not_logged_in"
                class="rounded"
                type="number"
                :rules="FieldNumbRequired('Lock User')"
                hide-spin-buttons
                dense
                outlined
                placeholder="Lock User (Within Days if not logged in)"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="5">
              <label class="required font-weight-large my-0">
                Invalid Control No.attempt(For a Day):
              </label>
              <v-text-field
                v-model="editedItem.invalid_control_no_attempt_for_a_day"
                class="rounded"
                type="number"
                :rules="FieldNumbRequired('Invalid Control No.attempt')"
                hide-spin-buttons
                dense
                outlined
                placeholder="Invalid Control No.attempt(For a Day)"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-space-around" no-gutters>
            <v-col cols="12" md="5">
              <label class="required font-weight-large my-0">
                Invalid Control No.attempt(For Continous):
              </label>
              <v-text-field
                v-model="editedItem.invalid_control_no_attempt_for_continuous"
                class="rounded"
                type="number"
                :rules="FieldNumbRequired('Invalid Control No.attempt')"
                hide-spin-buttons
                dense
                outlined
                placeholder="Invalid Control No.attempt(For Continous)"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5" class="d-flex justify-space-between">
              <v-switch
                v-model="editedItem.enable_global_operation_time"
                label="Enable Global Operation Time"
                class="me-2"
                hide-details
              ></v-switch>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-space-around" no-gutters>
            <v-col cols="12" md="5">
              <label class="required font-weight-large my-0">
                Operation Time From:
              </label>
              <v-dialog
                ref="dialogfrom"
                v-model="modal"
                :return-value.sync="editedItem.operation_time_from"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editedItem.operation_time_from"
                    class="rounded"
                    append-icon="mdi-clock-time-four-outline"
                    :rules="FieldRequired('Operation Time From')"
                    dense
                    outlined
                    placeholder="Select Operation Time From"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="modal"
                  format="24hr"
                  use-seconds
                  v-model="editedItem.operation_time_from"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    depressed
                    text
                    color="primary"
                    small
                    @click="modal = false"
                  >
                    <v-icon small class="me-2">mdi-close-circle-outline</v-icon>
                    Cancel
                  </v-btn>
                  <v-btn
                    depressed
                    text
                    small
                    color="primary"
                    @click="
                      $refs.dialogfrom.save(editedItem.operation_time_from)
                    "
                  >
                    OK
                  </v-btn>
                </v-time-picker>
              </v-dialog>
            </v-col>
            <v-col cols="12" md="5">
              <label class="required font-weight-large my-0">
                Operation Time To:
              </label>
              <v-dialog
                ref="dialog"
                v-model="modal2"
                :return-value.sync="editedItem.operation_time_to"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editedItem.operation_time_to"
                    class="rounded"
                    append-icon="mdi-clock-time-four-outline"
                    :rules="FieldRequired('Operation Time To')"
                    dense
                    outlined
                    placeholder="Select Operation Time To"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="modal2"
                  v-model="editedItem.operation_time_to"
                  format="24hr"
                  use-seconds
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    depressed
                    text
                    small
                    color="primary"
                    @click="modal2 = false"
                  >
                    <v-icon small class="me-2">mdi-close-circle-outline</v-icon>
                    Cancel
                  </v-btn>
                  <v-btn
                    depressed
                    text
                    small
                    color="primary"
                    @click="$refs.dialog.save(editedItem.operation_time_to)"
                  >
                    OK
                  </v-btn>
                </v-time-picker>
              </v-dialog>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-space-around" no-gutters>
            <v-col cols="12" md="5">
              <label class="required font-weight-large my-0">
                Change Password Interval:
              </label>
              <v-text-field
                v-model="editedItem.change_pwd_interval"
                class="rounded"
                type="number"
                :rules="FieldNumbRequired('Change Password Interval')"
                hide-spin-buttons
                dense
                outlined
                placeholder="Change Password Interval"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
              <v-switch
                v-model="editedItem.is_active"
                label="Active"
                class="me-2"
                hide-details
              ></v-switch>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider class="p-0 m-0"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed color="primary text-capitalize" small @click="save">
          <v-icon small class="me-2">mdi-content-save-edit-outline</v-icon>
          Update Format
        </v-btn>
      </v-card-actions>
    </v-card>
  </section>
</template>
<script>
import { FieldRequired ,FieldNumbRequired} from "../../utils/validation";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import Overlay from "../../utils/OverlayPage.vue";
import alerts from "../../mixins/alerts";
import setupService from "@/services/SetupService/setupService.js";
export default {
  name: "Password Format",
  mixins: [alerts],
  data: () => ({
    FieldRequired,
    FieldNumbRequired,
    valid: true,
    time: null,
    modal2: false,
    timefrom: null,
    modal: false,
    dialog: false,
    dialogDelete: false,
    show_overlay: false,
    savedItem: {},
    editedItem: {
      wrong_login_attempts_limit: 0,
      minimum_password_length: 0,
      password_record_history_number: 0,
      special_character: 0,
      numeric: 0,
      capital_alphabet: 0,
      lock_user_within_days_if_not_logged_in: 0,
      invalid_control_no_attempt_for_a_day: 0,
      invalid_control_no_attempt_for_continuous: 0,
      operation_time_from: null,
      operation_time_to: null,
      enable_global_operation_time: true,
      change_pwd_interval: 0,
      is_active: true,
    },
  }),
  components: {
    BreadCrumb,
    Overlay,
  },

  watch: {
    "editedItem.operation_time_from"(val) {
      console.log("time", val);
    },
    editedItem: {
      handler(newVal) {
        console.log("newVal", newVal);
        this.changedObject(newVal);
      },
      deep: true,
    },
  },

  mounted() {
    this.getFormatByid();
  },
  methods: {
    changedObject(newObj) {
      console.log("saved", this.savedItem);
      let key = JSON.stringify(this.savedItem) == JSON.stringify(newObj);
      console.log("key", key);
    },
    async save() {
      const validate = this.$refs.passwordFormat.validate();
      if (validate) {
        this.show_overlay = true;
        try {
          const responseData = await setupService.savePassword(this.editedItem);
          console.log(responseData);
          if (responseData.data.status_code === 200) {
            this.show_overlay = false;
            this.getFormatByid();
            this.showAlertSuccess(responseData.data.message);
          }
          // else if (responseData.data.status_code === 401) {
          //   this.returnNewToken();
          //   this.save();
          // }
          else {
            this.show_overlay = false;
            this.showAlertSuccess(responseData.data.message);
          }
        } catch (err) {
          this.show_overlay = false;
          console.log(err);
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
    async getFormatByid() {
      try {
        const responseData = await setupService.getFormatId();
        console.log(responseData);
        if (responseData.data.status_code === 200) {
          this.editedItem = responseData.data.data[0];
          this.savedItem = responseData.data.data[0];
          // this.showAlertSuccess(responseData.data.message);
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getFormatByid();
        // }
        else {
          this.showAlertError(responseData.data.message);
        }
      } catch (err) {
        console.log(err);
        this.showAlertError("Something went wrong please try again later.");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
</style>
